package com.islamicmedia.site.pages.isitsafe

import androidx.compose.runtime.Composable
import com.islamicmedia.site.components.PublicReviewPage
import com.varabyte.kobweb.core.Page

/** Public SEO review — "/isitsafe/zootopia". Pulls the REAL cached analysis (baked in StaticReviews). */
@Page("/isitsafe/zootopia")
@Composable
fun ZootopiaReviewPage() {
    PublicReviewPage(
        slug = "zootopia",
        blurb = "Is Zootopia OK for Muslim kids? Fitrah Filter checks movies, shows, games, and books against Islamic values. Here's the full breakdown for parents.",
    )
}
